// eslint-disable-next-line
const NEW_API_URL = apiUrl;

const axios = require('axios');

const actions = {
  /**
   * Загружает информацию об отделении с сервера
   *
   * @param {String} id Код отделения
   * @return {*}
   */
  find(id) {
    return axios.get(NEW_API_URL + `/odp/${id}`);
  },
  /**
   * Загружает список отделений в указанном городе
   *
   * @param {String} code код города
   * @param {String} count количество пунктов
   * @param {Array} filtrationSigns массив признаков для фильтрации отделений
   */
  findInCity(code, count, filtrationSigns) {
    // axios.get(ACCURATEWEB_API_URL + 'odp?cityCode=' + code +
    // '&select=title,address,id,fitting,photos,fittingType,workTime,geo,courierDelivery&perPage=10'
    // + queryParams, {headers: {Authorization: ACCURATEWEB_API_TOKEN}})
    let countPoints = count ? count : 10;
    let paramFilter = '';

    if (filtrationSigns) {
      filtrationSigns.forEach((item) => {
        paramFilter = `${paramFilter}&${item}=1`;
      });
    }
    return axios.get(
      NEW_API_URL + `/odp?cityCode=${code}&select=title,address,id,workTime,scheduleShort,phone,geo${paramFilter}&perPage=${countPoints}`
    );
  },


};

export { actions as default };
